import React, {useState} from 'react';
import {DebtorActionType} from './DebtorActionHelper';
import {MenuItem} from '@material-ui/core';
import DebtorEditAdditionalEmailsDialog from '../dialogs/DebtorEditAdditionalEmailsDialog';

const DebtorEditAdditionalEmailsAction = React.forwardRef(({ debtor, setMenuAnchor, label }: DebtorActionType, ref: React.Ref<any>) => {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <div key={debtor.id + 'debtorEditAdditionalEmailsC'} ref={ref}>
      <MenuItem
        key={debtor.id + 'debtorEditAdditionalEmails'}
        onClick={() => {
          setMenuAnchor(null);
          setOpenDialog(true);
        }}
      >
        {label}
      </MenuItem>
      {openDialog && <DebtorEditAdditionalEmailsDialog debtorId={debtor.id} open={openDialog} onClose={() => setOpenDialog(false)} />}
    </div>
  );
});

export default DebtorEditAdditionalEmailsAction;
